import _asyncToGenerator from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";
export var createFetchSource = function createFetchSource(createAbortError) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url);

            case 3:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return response.text();

            case 7:
              _context.t0 = _context.sent;
              _context.t1 = response.url;
              return _context.abrupt("return", [_context.t0, _context.t1]);

            case 10:
              _context.next = 14;
              break;

            case 12:
              _context.prev = 12;
              _context.t2 = _context["catch"](0);

            case 14:
              throw createAbortError();

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};